<template lang="pug">
div
  v-card(v-if="loaded")
    v-card-title.mw-50
      v-text-field#buscarDataTable.search(
        v-model="search",
        color="success",
        append-icon="mdi-magnify",
        label="Buscar",
        single-line,
        hide-details
      )
      v-btn.ml-2.white--text(
        v-if="!!addUrl",
        :to="addUrl",
        color="success",
        outlined
      ) Adicionar
        v-icon(right) mdi-plus-circle

      v-btn.ml-2.white--text(
        v-if="exportable",
        color="success",
        outlined,
        @click="exportToExcel"
      ) Excel
        v-icon(right) fa-file-excel

    v-divider
    v-data-table(
      :headers="fieldsVisiveis",
      :items="dados",
      :loading="!loaded",
      :footer-props="footerProps",
      :search="search",
      :item-key="chave",
      @current-items="emitCurrentItems"
    )
      template(slot="headerCell", slot-scope="{ header }")
        span.subheading.font-weight-regular.text-success.text--darken-3 {{ header.text }}

      template(v-slot:item.actions="{ item }")
        v-btn.mr-3(
          :icon="button.text === null",
          :rounded="button.text !== null",
          :outlined="button.text !== null",
          :small="button.text !== null",
          v-for="button in item.actions",
          :color="button.color",
          @click="retorno(button.name, item)",
          v-bind:key="item.name"
        ) {{ button.text }}
          v-icon(:right="button.text !== null") {{ button.icon }}

      template(v-slot:item="props")
        tr(@click="props.expanded = !props.expanded")
          td(v-for="field in fieldsVisiveis", :key="field.value")
            v-btn.mr-3(
              v-if="field.buttons && field.get(field, props.item).value == true",
              v-for="button in field.get(field, props.item).buttons",
              :outlined="button.text !== null",
              :small="true",
              :color="button.color",
              :title="button.title",
              v-bind:key="button.name",
              v-on:click="button.internalEvent ? $emit(button.eventName, props.item) : button.onClick(props.item)"
            )
              v-icon {{ button.icon }}

            router-link(
              :to="field.get(field, props.item).to",
              tag="a",
              v-if="field.link"
            )
              | {{ field.get(field, props.item).value }}

            span(v-if="!field.link && !field.icon && !field.buttons")
              | {{ field.get(field, props.item).value }}

            .row.no-gutters
              v-icon(
                v-if="field.icon",
                :color="field.get(field, props.item).color",
                :title="field.get(field, props.item).title"
              )
                |
                | {{ field.get(field, props.item).icon }}

              .ml-2 {{ field.get(field, props.item).title }}

      template(v-slot:no-data)
        v-card.elevation-0.pa-15
          div Nenhum registro encontrado
          v-btn.ma-2.white--text(
            :to="addUrl",
            v-if="!!addUrl",
            color="success",
            outlined
          ) Adicionar
            v-icon(right) mdi-plus-circle

      template(v-slot:expand="props", v-if="fieldsExtras.length")
        tr
          th(v-for="field in fieldsExtras", :key="field.value")
            | {{ field.text }}
        tr
          td(v-for="field in fieldsExtras", :key="field.value")
            router-link(
              :to="field.get(field, props.item).to",
              tag="a",
              v-if="field.link"
            )
              | {{ field.get(field, props.item).value }}
            span(v-if="!field.link && !field.icon")
              | {{ field.get(field, props.item).value }}

      template(
        v-slot:footer.page-text,
        v-if="footerButtons && footerButtons.length > 0",
        v-for="button in footerButtons"
      )
        v-btn(:color="button.color", :to="button.to") {{ button.text }}
          v-icon(:right="true") {{ button.icon }}
</template>

<script>
import ExcellentExport from "excellentexport";

export default {
  props: [
    "fields",
    "dados",
    "loaded",
    "order",
    "footerButtons",
    "addUrl",
    "exportable",
    "excelFileName",
  ],

  data: () => ({
    search: "",
    pagination: {},
    chave: "",
    footerProps: {
      itemsPerPageText: "Itens por página",
      itemsPerPageOptions: [15, 100, { text: "Todos", value: -1 }],
    },
    rowsPerPage: [50, 100, { text: "Todos", value: -1 }],
    fieldsVisiveis: {},
    fieldsExtras: {},
  }),

  mounted() {
    this.fieldsVisiveis = this.fields.filter((f) => !f.extra);
    this.fieldsExtras = this.fields.filter((f) => f.extra);
    this.pagination = this.order;
    this.chave = this.fields[0].value;
  },

  methods: {
    emitCurrentItems(value) {
      this.$emit("current-items", value);
    },

    exportToExcel() {
      try {
        const table = document.getElementsByTagName("table")[0];
        if (!table) {
          this.$toast.error("Tabela não encontrada");
          return;
        }

        const link = document.createElement("a");
        const fileName = this.excelFileName ?? "gifnoc-excel.xls";

        ExcellentExport.convert(
          {
            anchor: link,
            filename: fileName,
            format: "xls",
            openAsDownload: false,
          },
          [
            {
              name: "Dados",
              from: {
                table: table,
              },
            },
          ]
        );

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$toast.success("Arquivo Excel exportado com sucesso!");
      } catch (error) {
        console.error("Erro ao exportar para Excel:", error);
        this.$toast.error("Erro ao exportar para Excel");
      }
    },
  },
};
</script>

  <style>
.margin-200 {
  margin-top: 200px;
}
.search:focus-within {
  width: 400px;
}
.search-width {
  width: 0 !important;
}
td.label {
  height: 45px !important;
}
</style>
